export default __webpack_public_path__ + "static/media/portadapokemon.5b8a5f11.png";